export default {
  name: "HeatDiagram",
  props: { alert_time: Object, last_heat: String },
  methods: {
    timeSpentInPercentage(time, durationHours) {
      const now = this.$moment();
      return Math.min(100, Math.max(0, (1 - (time.diff(now, 'hours', true) / durationHours * 100))));
    },
    baseDate() {
      return this.$moment(this.alert_time)
    }
  },
  computed: {
    /* Explanation: time ranges are (0h-4h, 4h-7h, 7h-10h, 10h-14h) starting from alert_time */
    timeWaiting() {
      return this.timeSpentInPercentage(this.baseDate(), 6);
    },
    timeOptimal() {
      return this.timeSpentInPercentage(this.baseDate().add(6, 'hours'), 7);
    },
    timeSemen() {
      return this.timeSpentInPercentage(this.baseDate().add(6 + 7, 'hours'), 3);
    },
    timeLate() {
      return this.timeSpentInPercentage(this.baseDate().add(6 + 7 + 3, 'hours'), 4);
    },

    timeLeftForInsemination() {
      const now = this.$moment();
      const inseminationTime = this.baseDate().add(16, 'hours');

      if (now.isAfter(inseminationTime)) {
        return this.$t("dashboardView.alerts.expired");
      }

      const duration = this.$moment.duration(inseminationTime.diff(now));

      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();

      return this.$t("dashboardView.alerts.timeLeft") + ': ' + `${hours}:${minutes < 10 ? '0' : ''}${minutes}`
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/_heat-diagram/heat-diagram.js